export default __webpack_public_path__ + "static/media/right-arrow-icons-drawer.63a93f84.svg";